import { render, staticRenderFns } from "./EventOldSiteMenu.vue?vue&type=template&id=7680da27&scoped=true&"
import script from "./EventOldSiteMenu.vue?vue&type=script&lang=js&"
export * from "./EventOldSiteMenu.vue?vue&type=script&lang=js&"
import style0 from "./EventOldSiteMenu.vue?vue&type=style&index=0&id=7680da27&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7680da27",
  null
  
)

export default component.exports